import { legacyTheme, styled } from '@prose-ui/legacy';

import { IngredientInfos } from './IngredientInfos';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;

  & p {
    margin: 0;
  }

  ${legacyTheme.breakpoints.up('md')} {
    flex-direction: row;
    align-items: center;

    & p {
      margin: 10px;
    }
  }
`;

const Separator = styled.span`
  display: none;

  ${legacyTheme.breakpoints.up('md')} {
    display: block;
  }
`;

export const EwgInfos = () => (
  <Root>
    <IngredientInfos variant="p1">
      1-2: <span>High safety</span>
    </IngredientInfos>
    <Separator>-</Separator>
    <IngredientInfos variant="p1">
      3-6: <span>Moderate safety</span>
    </IngredientInfos>
    <Separator>-</Separator>
    <IngredientInfos variant="p1">
      7-10: <span>Low safety</span>
    </IngredientInfos>
    <Separator>-</Separator>
    <IngredientInfos variant="p1">
      N/A: <span>Not yet rated</span>
    </IngredientInfos>
  </Root>
);
